import { IconMail, IconMessage, IconMessageCircle, IconPhone } from '@tabler/icons-react'

import { CHANNEL_TYPE } from './constants'

export const CHANNEL_ICONS = {
  [CHANNEL_TYPE.CALL]: IconPhone,
  [CHANNEL_TYPE.EMAIL]: IconMail,
  [CHANNEL_TYPE.SMS]: IconMessage,
  [CHANNEL_TYPE.CHAT]: IconMessageCircle,
}
